import React from "react";
import { createRoot } from 'react-dom/client';

import App from "../app/club";
import styles from "stylesheets/club_admin.scss"

import axios from "axios";
axios.defaults.responseType = "json";

function initializeReactComponent() {
  const container = document.getElementById('page-wrapper');
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
}

document.addEventListener("turbolinks:load", () => {
  initializeReactComponent();
});

// Fallback for when Turbolinks is not used or if Turbolinks is not available
document.addEventListener("DOMContentLoaded", () => {
  initializeReactComponent();
});
